import styled from '@emotion/styled';

export const NavMain = styled.nav`
  display: flex;

  @media screen and (min-width: 1280px) {
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
